import { render, staticRenderFns } from "./CambiarAFacturaAbono.vue?vue&type=template&id=5b4853e6&scoped=true&lang=pug"
import script from "./CambiarAFacturaAbono.vue?vue&type=script&lang=js"
export * from "./CambiarAFacturaAbono.vue?vue&type=script&lang=js"
import style0 from "./CambiarAFacturaAbono.vue?vue&type=style&index=0&id=5b4853e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4853e6",
  null
  
)

export default component.exports